module.exports = __webpack_public_path__ + "static/media/Pollo navideño a la sidra.49e240a0.png";